import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=b907580c&scoped=true&"
import script from "./Instructions.vue?vue&type=script&lang=ts&"
export * from "./Instructions.vue?vue&type=script&lang=ts&"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=b907580c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b907580c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b907580c')) {
      api.createRecord('b907580c', component.options)
    } else {
      api.reload('b907580c', component.options)
    }
    module.hot.accept("./Instructions.vue?vue&type=template&id=b907580c&scoped=true&", function () {
      api.rerender('b907580c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Instructions.vue"
export default component.exports